import React from 'react'
import PropTypes from 'prop-types'

import { Box } from '@chatterbug/aaron'

const RateActivityStar = ({ active }) => {
  return (
    <Box
      sx={{
        width: '42px',
        height: '40px',
        position: 'relative',
      }}
    >
      <svg
        width="42"
        height="40"
        viewBox="0 0 42 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19.2864 1.84744C20.0637 0.555805 21.9363 0.555802 22.7136 1.84744L28.1338 10.8539C28.413 11.3179 28.8685 11.6488 29.3961 11.771L39.6367 14.1428C41.1053 14.4829 41.684 16.2638 40.6958 17.4023L33.805 25.3403C33.45 25.7493 33.276 26.2847 33.3229 26.8243L34.2317 37.2965C34.3621 38.7984 32.8471 39.8991 31.459 39.311L21.7802 35.2105C21.2815 34.9993 20.7185 34.9993 20.2198 35.2105L10.541 39.311C9.1529 39.8991 7.63794 38.7984 7.76828 37.2965L8.67713 26.8243C8.72396 26.2847 8.54997 25.7493 8.19495 25.3403L1.30424 17.4023C0.316027 16.2639 0.894688 14.4829 2.36332 14.1428L12.6039 11.771C13.1315 11.6488 13.587 11.3179 13.8662 10.8539L19.2864 1.84744Z"
          fill="#E0E0E0"
        />
      </svg>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          opacity: active ? 1 : 0,
          transition: 'opacity 0.3s ease',
        }}
      >
        <svg
          width="41"
          height="40"
          viewBox="0 0 41 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M18.5364 1.84744C19.3137 0.555805 21.1863 0.555802 21.9636 1.84744L27.3838 10.8539C27.663 11.3179 28.1185 11.6488 28.6461 11.771L38.8867 14.1428C40.3553 14.4829 40.934 16.2638 39.9458 17.4023L33.055 25.3403C32.7 25.7493 32.526 26.2847 32.5729 26.8243L33.4817 37.2965C33.6121 38.7984 32.0971 39.8991 30.709 39.311L21.0302 35.2105C20.5315 34.9993 19.9685 34.9993 19.4698 35.2105L9.79097 39.311C8.4029 39.8991 6.88794 38.7984 7.01828 37.2965L7.92713 26.8243C7.97396 26.2847 7.79997 25.7493 7.44495 25.3403L0.554244 17.4023C-0.433973 16.2639 0.144688 14.4829 1.61332 14.1428L11.8539 11.771C12.3815 11.6488 12.837 11.3179 13.1162 10.8539L18.5364 1.84744Z"
            fill="#F4C856"
          />
        </svg>
      </Box>
    </Box>
  )
}

RateActivityStar.propTypes = {
  active: PropTypes.bool,
}

export default RateActivityStar
